import React from 'react';
import TopLinks from './toplinks';
import SearchBar from './searchbar';
import TopPanel from './panels/top';
import MiddlePanel from './panels/middle';
import BottomPanel from './panels/bottom';
import MobileView from './mobile';

export default class Header extends React.Component {
  static propTypes = {
    discover: React.PropTypes.object
  };

  render () {
    return (
      <header className="header">
        <MobileView {...this.props} />
        <div className="header__desktop">
          <TopLinks key="toplinks" languageDropdown {...this.props} />
          <TopPanel key="toppanel" {...this.props} />
          <SearchBar key="searchbar" outlineSearch {...this.props} />
          <MiddlePanel key="middlepanel" lightBg {...this.props} />
          <BottomPanel key="botpanel" lightBg {...this.props} />
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/index.js